import React from 'react';
import PropTypes from 'prop-types';
import SelectItem from '../select-item';

const YearFilter = props => (
  <SelectItem
    options={props.options}
    selectedOptVal={props.selectedOptVal}
    onSelect={props.onSelect}
    onClose={props.onClose}
    heading={'Select Year'}
    showCloseButton
  />
);

YearFilter.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedOptVal: PropTypes.node,
};

YearFilter.defaultProps = {
  onClose: undefined,
  selectedOptVal: undefined,
};

export default YearFilter;
